// extracted by mini-css-extract-plugin
export default {"AuthorPanel":"AuthorPanel_AuthorPanel__ejxR4","Header":"AuthorPanel_Header__-wGzr","AuthorName":"AuthorPanel_AuthorName__FKsmE"};